import * as React from 'react';
import { Component } from 'react';
import { Tournament } from 'Src/models/tournament';
import {
  BADMINTON_FINALS_STAGES,
  BADMINTON_GROUP_STAGES,
  BADMINTON_QUALIFIERS_STAGES,
  BADMINTON_THIRD_PLACE_STAGES,
  FOOTBALL_FINALS_STAGES,
  FOOTBALL_GROUP_STAGES,
  FOOTBALL_PLAYOFF_STAGES,
  FOOTBALL_QUALIFIERS_STAGES,
  FOOTBALL_THIRD_PLACE_STAGES,
  RUGBY_GROUP_STAGES,
  RUGBY_PLAYOFF_STAGES,
  SWIMMING_GROUP_STAGES,
  TOURNAMENT_GROUP_TAG_MAPPING,
  TOURNAMENT_GROUP_TAG_MAPPING_REVERSE
} from 'Src/consts/tournament';
import { Field, Form, Formik } from 'formik';
import { Button } from 'Src/components/Button/Button';
import {
  isFinalStageExist,
  isGroupStageExist,
  isPlayoffStageExist,
  isQualifierStageExist
} from 'Src/helpers/tournament/tournament';
import { Switch } from 'Src/components/Switch/Switch';

interface Props {
  tournament: Tournament;
  onCancel: () => void;
  onSubmit: (data) => void;
}

export class TournamentAllGroupsForm extends Component<Props> {
  renderGroups(groups: string[], values, setFieldValue): React.ReactNode {
    return (
      <div className="tournamentDefaultGroupsForm__chips">
        {groups.map((group, index) => (
          <div key={`group_${index}`} style={{ display: 'flex' }}>
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                checked={values[group]}
                onChange={() => setFieldValue(group, !values[group])}
                className="custom-control-input"
                id={`switch_group_${group}`}
              />
              <label className="custom-control-label" htmlFor={`switch_group_${group}`}>
                {TOURNAMENT_GROUP_TAG_MAPPING[group]}
              </label>
            </div>
          </div>
        ))}
      </div>
    );
  }

  getTournamentGroups(): string[] {
    const { tournament } = this.props;
    const { customGroups, stages: groupsDeprecated } = tournament;

    const customGroupsFiltered = customGroups
      .filter(customGroup => {
        const customGroupName = customGroup.name;
        const customGroupNameMapped = TOURNAMENT_GROUP_TAG_MAPPING_REVERSE[customGroupName];

        return typeof customGroupNameMapped !== 'undefined';
      })
      .map(customGroup => {
        const customGroupName = customGroup.name;
        const customGroupNameMapped = TOURNAMENT_GROUP_TAG_MAPPING_REVERSE[customGroupName];
        return customGroupNameMapped;
      });

    return [...groupsDeprecated, ...customGroupsFiltered];
  }

  getGroupValue(group): boolean {
    const tournamentGroups = this.getTournamentGroups();
    const tournamentGroupIndex = tournamentGroups.findIndex(tournamentGroup => tournamentGroup === group);

    return tournamentGroupIndex !== -1;
  }

  getGroupsObject(groupList) {
    let groupsObject = {};

    groupList.forEach(group => {
      groupsObject[group] = this.getGroupValue(group);
    });

    return groupsObject;
  }

  getAllGroups() {
    const { tournament } = this.props;

    let groups = {};

    if (isGroupStageExist(tournament)) {
      const groupGroups = [
        ...FOOTBALL_GROUP_STAGES,
        ...BADMINTON_GROUP_STAGES,
        ...RUGBY_GROUP_STAGES,
        ...SWIMMING_GROUP_STAGES
      ];

      const groupsObject = this.getGroupsObject(groupGroups);
      groups = { ...groups, ...groupsObject };
    }

    if (isQualifierStageExist(tournament)) {
      const qualifierGroups = [...FOOTBALL_QUALIFIERS_STAGES, ...BADMINTON_QUALIFIERS_STAGES];

      const groupsObject = this.getGroupsObject(qualifierGroups);
      groups = { ...groups, ...groupsObject };
    }

    if (isPlayoffStageExist(tournament)) {
      const playoffGroups = [
        ...FOOTBALL_PLAYOFF_STAGES,
        ...FOOTBALL_THIRD_PLACE_STAGES,
        ...BADMINTON_THIRD_PLACE_STAGES,
        ...RUGBY_PLAYOFF_STAGES
      ];

      const groupsObject = this.getGroupsObject(playoffGroups);
      groups = { ...groups, ...groupsObject };
    }

    if (isFinalStageExist(tournament)) {
      const finalGroups = [...FOOTBALL_FINALS_STAGES, ...BADMINTON_FINALS_STAGES];

      const groupsObject = this.getGroupsObject(finalGroups);
      groups = { ...groups, ...groupsObject };
    }

    return groups;
  }

  renderAllGroups(values, setFieldValue): React.ReactNode {
    const { tournament } = this.props;
    let groupAndQualifier = [];

    if (isGroupStageExist(tournament)) {
      groupAndQualifier.push(
        <div
          key="group_stage"
          style={{
            fontWeight: 600,
            fontSize: 13,
            color: '#5b6b7b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 16,
            marginBottom: 6
          }}
        >
          Group Stage
        </div>
      );
      groupAndQualifier.push(this.renderGroups(FOOTBALL_GROUP_STAGES, values, setFieldValue));
      groupAndQualifier.push(
        <div
          key="group_stage_badminton"
          style={{
            fontWeight: 600,
            fontSize: 13,
            color: '#5b6b7b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 16,
            marginBottom: 6
          }}
        >
          Group Stage Badminton
        </div>
      );
      groupAndQualifier.push(this.renderGroups(BADMINTON_GROUP_STAGES, values, setFieldValue));
      groupAndQualifier.push(
        <div
          key="group_stage_rugby"
          style={{
            fontWeight: 600,
            fontSize: 13,
            color: '#5b6b7b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 16,
            marginBottom: 6
          }}
        >
          Group Stage Rugby
        </div>
      );
      groupAndQualifier.push(this.renderGroups(RUGBY_GROUP_STAGES, values, setFieldValue));
      groupAndQualifier.push(
        <div
          key="group_stage_swimming"
          style={{
            fontWeight: 600,
            fontSize: 13,
            color: '#5b6b7b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 16,
            marginBottom: 6
          }}
        >
          Group Stage Swimming
        </div>
      );
      groupAndQualifier.push(this.renderGroups(SWIMMING_GROUP_STAGES, values, setFieldValue));
    }

    if (isQualifierStageExist(tournament)) {
      groupAndQualifier.push(
        <div
          key="qualifier_stage"
          style={{
            fontWeight: 600,
            fontSize: 13,
            color: '#5b6b7b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 16,
            marginBottom: 6
          }}
        >
          Qualifiers Stage
        </div>
      );
      groupAndQualifier.push(this.renderGroups(FOOTBALL_QUALIFIERS_STAGES, values, setFieldValue));
      groupAndQualifier.push(this.renderGroups(BADMINTON_QUALIFIERS_STAGES, values, setFieldValue));
    }

    let playoffAndFinal = [];

    if (isPlayoffStageExist(tournament)) {
      playoffAndFinal.push(
        <div
          key="playoff_stage"
          style={{
            fontWeight: 600,
            fontSize: 13,
            color: '#5b6b7b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 16,
            marginBottom: 6
          }}
        >
          Playoff Stage
        </div>
      );
      playoffAndFinal.push(this.renderGroups(FOOTBALL_PLAYOFF_STAGES, values, setFieldValue));
      playoffAndFinal.push(this.renderGroups(FOOTBALL_THIRD_PLACE_STAGES, values, setFieldValue));
      playoffAndFinal.push(this.renderGroups(BADMINTON_THIRD_PLACE_STAGES, values, setFieldValue));
      playoffAndFinal.push(
        <div
          key="playoff_stage_rugby"
          style={{
            fontWeight: 600,
            fontSize: 13,
            color: '#5b6b7b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 16,
            marginBottom: 6
          }}
        >
          Playoff Stage Rugby
        </div>
      );
      playoffAndFinal.push(this.renderGroups(RUGBY_PLAYOFF_STAGES, values, setFieldValue));
    }

    if (isFinalStageExist(tournament)) {
      playoffAndFinal.push(
        <div
          key="final_stage"
          style={{
            fontWeight: 600,
            fontSize: 13,
            color: '#5b6b7b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 16,
            marginBottom: 6
          }}
        >
          Finals Stage
        </div>
      );
      playoffAndFinal.push(this.renderGroups(FOOTBALL_FINALS_STAGES, values, setFieldValue));
      playoffAndFinal.push(this.renderGroups(BADMINTON_FINALS_STAGES, values, setFieldValue));
    }

    return (
      <div className="row">
        <div className="col-md-6">{groupAndQualifier}</div>
        <div className="col-md-6">{playoffAndFinal}</div>
      </div>
    );
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <Formik
              initialValues={this.getAllGroups()}
              onSubmit={values => {
                this.props.onSubmit(values);
              }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <div className="form-group form-check">
                    {this.renderAllGroups(values, setFieldValue)}
                    <div className="tournamentDefaultGroupsForm__actions">
                      <Button
                        onClick={this.props.onCancel}
                        text={'Cancel'}
                        customClass={'tournamentDefaultGroupsForm__cancel'}
                      />
                      <button type="submit" className="tournamentDefaultGroupsForm__save">
                        Save groups
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}
